import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';

type FeedbackStatus = 'idle' | 'submitting' | 'succeeded' | 'failed';

interface FeedbackState {
  open: boolean;
  status: FeedbackStatus;
  error: string | null;
  lastSubmissionId: string | null;
}

const initialState: FeedbackState = {
  open: false,
  status: 'idle',
  error: null,
  lastSubmissionId: null,
};

const feedbackSlice = createSlice({
  name: 'feedback',
  initialState,
  reducers: {
    openModal(state) {
      state.open = true;
      state.error = null;
    },
    closeModal(state) {
      state.open = false;
      if (state.status !== 'submitting') {
        state.status = 'idle';
      }
    },
    startSubmit(state) {
      state.status = 'submitting';
      state.error = null;
    },
    submitSuccess(state, action: PayloadAction<{ id: string | null }>) {
      state.status = 'succeeded';
      state.lastSubmissionId = action.payload.id;
    },
    submitFailure(state, action: PayloadAction<string | null | undefined>) {
      state.status = 'failed';
      state.error = action.payload ?? 'Failed to send feedback';
    },
    resetStatus(state) {
      state.status = 'idle';
      state.error = null;
    },
  },
});

export const feedbackActions = feedbackSlice.actions;

export const selectFeedbackOpen = (state: RootState) => state.feedback.open;
export const selectFeedbackStatus = (state: RootState) => state.feedback.status;
export const selectFeedbackError = (state: RootState) => state.feedback.error;

export default feedbackSlice.reducer;
